var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 mb-2 bg-primary text-white rounded",class:_vm.gradient ? 'bg-gradient' : null,style:(_vm.cssVariables)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }